// Styles are imported in index.js
import Nav from './Nav';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import Home from './pages/Home/Home';
import Projects from './pages/Projects/Projects';
import Resume from './pages/Resume/Resume';
import Education from './pages/Education/Education';
import Volunteering from './pages/Volunteering/Volunteering';
import { ROUTES } from './config/constants';

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <div className="app">
          <Nav />
          <div className="app__container">
            <ErrorBoundary>
              <Routes>
                <Route path={ROUTES.HOME} element={<Home />} />
                <Route path={ROUTES.PROJECTS} element={<Projects />} />
                <Route path={ROUTES.RESUME} element={<Resume />} />
                <Route path={ROUTES.EDUCATION} element={<Education />} />
                <Route path={ROUTES.VOLUNTEERING} element={<Volunteering />} />
              </Routes>
            </ErrorBoundary>
          </div>
        </div>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
